import { sweetAlert, AlertType, AlertTitle, baseAPIUrl, bindAndInitSelect2, getHtml_HandleBar, httpPostHandleResponse, formatDate_MMMDDYYYY, baseWebUrl, clearSelectPickerValue, getQueryString, isNullOrEmpty, bindFlatpickr } from "../../utils/common";
import { Loader } from "../../services/loaderService";
import "datatables.net";
import http, { GetToken, GetTokenForDataTable } from "../../services/httpService";
import moment = require("moment");
declare var KTAvatar: any;
import "dropzone";
import Dropzone = require("dropzone");
import { DocumentManager } from "../_DocumentManager";
import { DocumentRequests } from "../_DocumentRequests";

class Contants {
    readonly controller: string = baseAPIUrl() ? `${baseAPIUrl()}/Employee` : '/Employee';
    readonly clientController: string = baseAPIUrl() ? `${baseAPIUrl()}/Client` : '/Client';
    readonly DepartmentController: string = baseAPIUrl() ? `${baseAPIUrl()}/Department` : '/Department';
    readonly controllerUser: string = baseAPIUrl() ? `${baseAPIUrl()}/User` : '/User';
    readonly DocumentTypeController: string = baseAPIUrl() ? `${baseAPIUrl()}/DocumentType` : '/DocumentType';
    readonly controllerDocuments: string = baseAPIUrl() ? `${baseAPIUrl()}/EmployeeDocuments` : '/EmployeeDocuments';

    readonly MediaFilePath: string = baseWebUrl() + '/media/Users/';
    readonly btnSave: string = "#btnSave";

    readonly txtUserFirstName: string = "#txtUserFirstName";
    readonly txtUserMiddleName: string = "#txtUserMiddleName";
    readonly txtUserLastName: string = "#txtUserLastName";
    readonly txtUserPhone: string = "#txtUserPhone";
    readonly txtUserEmail: string = "#txtUserEmail";

    readonly ddlClient: string = "#ddlClient";
    readonly ddlDepartment: string = "#ddlDepartment";
    readonly ddlEmpIds: string = "#ddlEmployee";

    readonly tmpl_option: string = "#tmpl_option";
    readonly tmpl_options: string = "#tmpl_options";

    readonly up_Media: string = "up_Media";
    readonly profile_avatar: string = '#profile_avatar';
    readonly kt_avatar_image_holder: string = '#kt_avatar_image_holder';
    readonly clearSelectPicker: string = ".clearSelectPicker";

    readonly btnSearch: string = "#btnSearch";
}

class Profile {
    loader: Loader = new Loader();
    constants: Contants = new Contants();

    userData: any = {};
    filterObject: any = {};
    employees: any = [];
    departments: any = [];
    clients: any = [];
    requestedUserId: any = 0;
    private documentManager: DocumentManager;
    private documentRequests: DocumentRequests;

    $txtUserFirstName: JQuery<HTMLElement>;
    $txtUserMiddleName: JQuery<HTMLElement>;
    $txtUserLastName: JQuery<HTMLElement>;
    $txtUserPhone: JQuery<HTMLElement>;
    $txtUserEmail: JQuery<HTMLElement>;
    $btnSave: JQuery<HTMLElement>;

    $ddlClient: JQuery<Element>;
    $ddlDepartment: JQuery<Element>;
    $ddlEmpIds: JQuery<HTMLElement>;

    $up_Media: any;
    $file: JQuery<HTMLInputElement>;
    $kt_avatar_image_holder: JQuery<HTMLElement>;
    $clearSelectPicker: JQuery<Element>;

    $btnSearch: JQuery<Element>;

    constructor() {
        this.Init();
    }

    private applyEobiVisibility = () => {
        try {
            const raw = localStorage.getItem("Configuration");
            const $eobi = $("#EOBIContainer");
            if (!$eobi.length) return;

            if (!raw) {
                $eobi.addClass("d-none");
                return;
            }
            const configArr = JSON.parse(raw);
            const eobiConfig = Array.isArray(configArr)
                ? configArr.find((c: any) => c.Page === "Employee" && c.Key === "EOBIContainer")
                : null;

            if (eobiConfig && typeof eobiConfig.IsEnabled !== "undefined") {
                if (eobiConfig.IsEnabled) {
                    $eobi.removeClass("d-none");
                } else {
                    $eobi.addClass("d-none");
                }
            } else {
                $eobi.addClass("d-none");
            }
        } catch {
            $("#EOBIContainer").addClass("d-none");
        }
    };

    private Init = async () => {
        this.loader.showLoader();
        this.BindEvent();
        this.getObjById();
        await this.getAllClients();
        await this.getAllDepartments();

        // Ensure employee select is initialized on load (empty) only if element exists
        if (this.$ddlEmpIds && this.$ddlEmpIds.length) {
            bindAndInitSelect2(this.$ddlEmpIds, [], false, this.constants.tmpl_options);
        }

        this.loader.hideLoader();

        this.userData = JSON.parse(localStorage.getItem('UserData'));

        const params = getQueryString();

        if (!(params.tabid == null || params.tabid == undefined || params.tabid === "")) {
            $('.nav-item a[href="#' + params.tabid + '"]').tab('show')
        }

        // Hide/Show Save button based on active tab on load
        const activeTab = $('.nav-item a.active').attr('href');
        if (activeTab === '#kt_tabs_7_3' || activeTab === '#kt_tabs_7_4') {
            $(this.constants.btnSave).addClass('d-none');
        } else {
            $(this.constants.btnSave).removeClass('d-none');
        }
    }

    private BindEvent = async () => {
        this.$txtUserFirstName = $(this.constants.txtUserFirstName);
        this.$txtUserLastName = $(this.constants.txtUserLastName);
        this.$txtUserMiddleName = $(this.constants.txtUserMiddleName);
        this.$txtUserPhone = $(this.constants.txtUserPhone);
        this.$txtUserEmail = $(this.constants.txtUserEmail);
        this.$btnSave = $(this.constants.btnSave);

        // KTAvatar may not be available in all builds — guard it so BindEvent does not throw.
        try {
            if (typeof KTAvatar !== 'undefined' && KTAvatar) {
                this.$up_Media = new KTAvatar(this.constants.up_Media);
            } else {
                this.$up_Media = null;
            }
        } catch {
            this.$up_Media = null;
        }

        this.$file = $(this.constants.profile_avatar);
        this.$kt_avatar_image_holder = $(this.constants.kt_avatar_image_holder);

        this.$ddlClient = $(this.constants.ddlClient);
        this.$ddlDepartment = $(this.constants.ddlDepartment);
        this.$ddlEmpIds = $(this.constants.ddlEmpIds);
        this.$clearSelectPicker = $(this.constants.clearSelectPicker);

        this.$btnSearch = $(this.constants.btnSearch);

        // ensure selects exist before accessing .val()
        try { if (this.$ddlDepartment) this.$ddlDepartment.val(); } catch { }
        try { if (this.$ddlEmpIds) this.$ddlEmpIds.val(); } catch { }

        // Use a clear handler that works for both bootstrap-select and Select2
        $(document).off('click', '.clearSelectPicker').on('click', '.clearSelectPicker', (e) => {
            try {
                const $btn = $(e.currentTarget);
                const $select = $btn.closest('.input-group').find('select').first();
                if (!$select || $select.length === 0) {
                    const $siblingSelect = $btn.siblings('select').first();
                    if ($siblingSelect && $siblingSelect.length) {
                        if ($siblingSelect.data('select2')) $siblingSelect.val(null).trigger('change');
                        else $siblingSelect.val('').trigger('change');
                    }
                    return;
                }

                if ($select.data('select2')) {
                    $select.val(null).trigger('change');
                } else {
                    $select.val('').trigger('change');
                }
            } catch (err) {
                try { clearSelectPickerValue(e as any); } catch { /* ignore */ }
            }
        });

        this.$btnSearch.on('click', this.btnSearchClick);

        $(this.$btnSave).on('click', this.save);

        $(document).on('change', this.constants.ddlClient, this.ClientChangeEvent);
        $(document).on('change', this.constants.ddlDepartment, this.DepartmentChangeEvent);
        $(document).on('change', '#chkActiveEmployees', this.toggleActiveEmployee);

        this.applyEobiVisibility();

        $('a[data-bs-toggle="tab"]').on('shown.bs.tab', (e: any) => {
            const targetHref = $(e.target).attr('href');
            if (targetHref === '#kt_tabs_7_3' || targetHref === '#kt_tabs_7_4') {
                $(this.constants.btnSave).addClass('d-none');
            } else {
                $(this.constants.btnSave).removeClass('d-none');
            }
        });

        // Apply distinct styling to all readonly inputs
        $('input[readonly]').css({
            'background-color': '#e9ecef',
            'cursor': 'not-allowed',
            'opacity': '1',
            'color': '#6c757d'
        });

        // Initialize datepickers
        bindFlatpickr("#txtDOB", "M d, Y", null, null, null, null, '');
        bindFlatpickr("#txtCNICIssueDate", "M d, Y", null, null, null, null, '');
        bindFlatpickr("#txtCNICExpiryDate", "M d, Y", null, null, null, null, '');
    }

    private toggleActiveEmployee = async () => {
        const val: any = (this.$ddlClient && this.$ddlClient.length) ? this.$ddlClient.val() : null;

        if (!(val == null || val == undefined || val == "" || val.length == 0)) {
            this.getEmployees();
        }
    }

    private btnSearchClick = async () => {
        this.getObjById();
    }

    private getAllClients = async () => {
        GetToken();
        const response = await http.post(this.constants.clientController + "/GetAllActive");
        this.clients = httpPostHandleResponse(response);
        // bind to select2
        if (this.$ddlClient && this.$ddlClient.length) {
            bindAndInitSelect2(this.$ddlClient, this.clients, false, this.constants.tmpl_option);
        }
        this.loader.hideLoader();
    }

    private getAllDepartments = async () => {
        GetToken();
        const response = await http.post(this.constants.DepartmentController + "/GetAllActive");
        this.departments = httpPostHandleResponse(response);

        // bind Department select immediately so it shows on page load
        if (this.$ddlDepartment && this.$ddlDepartment.length) {
            bindAndInitSelect2(this.$ddlDepartment, this.departments, false, this.constants.tmpl_option);
        }

        this.loader.hideLoader();
    }

    private ClientChangeEvent = async (event: JQueryEventObject) => {
        const val: any = (this.$ddlClient && this.$ddlClient.length) ? this.$ddlClient.val() : null;

        if (val == null || val == undefined || val == "" || val.length == 0) {
            if (this.$ddlDepartment && this.$ddlDepartment.length) bindAndInitSelect2(this.$ddlDepartment, this.departments, false, this.constants.tmpl_option);
        } else {
            const depts = this.departments.filter((a: any) => { return val == a.ClientId; });
            if (this.$ddlDepartment && this.$ddlDepartment.length) bindAndInitSelect2(this.$ddlDepartment, depts, false, this.constants.tmpl_option);
            await this.getEmployees();
        }
        this.loader.hideLoader();
    }

    private DepartmentChangeEvent = async (event: JQueryEventObject) => {
        const val: any = (this.$ddlDepartment && this.$ddlDepartment.length) ? this.$ddlDepartment.val() : null;
        if (val && (val as any).length > 0) {
            this.getEmployees();
        }
    }

    private getEmployees = async (data: any = null) => {
        this.loader.showLoader()

        const filterObject: any = {
            ClientIds: [(this.$ddlClient && this.$ddlClient.length) ? this.$ddlClient.val() : null],
            SectionIds: [],
            DepartmentIds: [],
            IncludeBaseClient: false,
            IncludeActiveUsers: $('#chkActiveEmployees').is(':checked')
        }

        const deptId: any = (this.$ddlDepartment && this.$ddlDepartment.length) ? this.$ddlDepartment.val() : null;
        if (deptId != undefined && deptId != null && deptId != "")
            filterObject.DepartmentIds.push(deptId);

        if (data != null || JSON.stringify(filterObject) != JSON.stringify(this.filterObject)) {
            this.filterObject = (data == null ? filterObject : data);
            GetToken();
            if ((this.filterObject.ClientIds && this.filterObject.ClientIds.length > 0) || (this.filterObject.SectionIds && this.filterObject.SectionIds.length > 0) || (this.filterObject.DepartmentIds && this.filterObject.DepartmentIds.length > 0)) {
                const response = await http.post(this.constants.controllerUser + "/GetAllActiveByFilterObject/", this.filterObject);
                this.employees = httpPostHandleResponse(response);
                // bind using the employees template
                if (this.$ddlEmpIds && this.$ddlEmpIds.length) bindAndInitSelect2(this.$ddlEmpIds, this.employees, false, this.constants.tmpl_options);
            } else {
                this.employees = [];
                if (this.$ddlEmpIds && this.$ddlEmpIds.length) bindAndInitSelect2(this.$ddlEmpIds, [], false, this.constants.tmpl_options);
            }
        }
        this.loader.hideLoader();
    }

    private getObjById = async () => {
        this.loader.showLoader();

        GetToken();

        let isParamKeyExist: boolean = false;

        this.userData = JSON.parse(localStorage.getItem('UserData'));

        const params: any = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop: any) => searchParams.get(prop),
        });

        const emp: any = (this.$ddlEmpIds && this.$ddlEmpIds.length) ? this.$ddlEmpIds.val() : null;

        if (emp != null && emp != undefined && emp !== '')
            this.requestedUserId = emp;
        else if (params.key == null || params.key == undefined || params.key == 0)
            this.requestedUserId = this.userData.Id;
        else {
            this.requestedUserId = params.key;
            isParamKeyExist = true;
        }

        let Permissioncheck = this.userData.Permissions.indexOf('View_OthersProfile');

        if (this.userData.UserType == 1 || this.userData.UserType == 2 || Permissioncheck > -1) {
            if (!isParamKeyExist) {
                $('.View_OthersProfile').removeClass('d-none');
                // re-bind selects now they are visible
                try {
                    if (this.$ddlDepartment && this.$ddlDepartment.length) bindAndInitSelect2(this.$ddlDepartment, this.departments || [], false, this.constants.tmpl_option);
                    if (this.$ddlEmpIds && this.$ddlEmpIds.length) bindAndInitSelect2(this.$ddlEmpIds, this.employees || [], false, this.constants.tmpl_options);
                } catch { /* ignore */ }
            }
        }
        else {
            $('.View_OthersProfile').addClass('d-none');
        }

        if (this.requestedUserId != this.userData.Id) {
            if (this.userData.UserType != 1 && this.userData.UserType != 2 && this.userData.Permissions.indexOf('View_OthersProfile') == -1) {
                this.requestedUserId = this.userData.Id;
                sweetAlert(AlertType.Warning, AlertTitle.Error, "You do not have permission to View Other User's Profile");
            }
        }

        const response = await http.get(this.constants.controller + "/GetLoggedinEmployeeData/" + this.requestedUserId);
        const data: any = httpPostHandleResponse(response);
        if (data) {
            const EmployeeInformation = data.EmployeeInformation;
            if (!isNullOrEmpty(EmployeeInformation.Picture))
                $("#imgUserImage").attr('src', EmployeeInformation.Picture);
            this.$txtUserFirstName.val(EmployeeInformation.FirstName);
            this.$txtUserLastName.val(EmployeeInformation.LastName);
            $('#txtPostingCity').val(EmployeeInformation.PostingCity);
            $('#txtCode').val(EmployeeInformation.Code);
            if (EmployeeInformation.HireDate != null && formatDate_MMMDDYYYY(EmployeeInformation.HireDate) !== "Jan 1, 2001") {
                $('#txtHireDate').val(formatDate_MMMDDYYYY(EmployeeInformation.HireDate));
            }
            if (EmployeeInformation.TermDate != null && formatDate_MMMDDYYYY(EmployeeInformation.TermDate) !== "Jan 1, 2001") {
                $('#txtTermDate').val(formatDate_MMMDDYYYY(EmployeeInformation.TermDate));
            }
            $('#txtTermReason').val(EmployeeInformation.TermReason);
            $('#txtDesignation').val(EmployeeInformation.Designation);
            $('#txtSection').val(EmployeeInformation.Section);
            $('#txtDepartment').val(EmployeeInformation.Department);
            $('#txtAddress').val(EmployeeInformation.Address);
            $('#txtCity').val(EmployeeInformation.City);
            $('#txtProvince').val(EmployeeInformation.State);
            $('#txtReferenceName').val(EmployeeInformation.ReferenceName);
            $('#txtReferenceContact').val(EmployeeInformation.ReferenceContact);
            $('#txtOfficialEmail').val(EmployeeInformation.OfficialEmail);
            $('#txtCNIC').val(EmployeeInformation.Cnic);
            $('#txtReligion').val(EmployeeInformation.Religion);
            $('#txtEmployeementType').val(EmployeeInformation.EmployeementType);
            $('#txtLastDegree').val(EmployeeInformation.LastDegree);
            if (EmployeeInformation.CnicIssueDate != null && formatDate_MMMDDYYYY(EmployeeInformation.CnicIssueDate) !== "Jan 1, 2001") {
                $('#txtCNICIssueDate').val(formatDate_MMMDDYYYY(EmployeeInformation.CnicIssueDate));
            }
            if (EmployeeInformation.CnicExpiryDate != null && formatDate_MMMDDYYYY(EmployeeInformation.CnicExpiryDate) !== "Jan 1, 2001") {
                $('#txtCNICExpiryDate').val(formatDate_MMMDDYYYY(EmployeeInformation.CnicExpiryDate));
            }
            if (EmployeeInformation.DateOfBirth != null && formatDate_MMMDDYYYY(EmployeeInformation.DateOfBirth) !== "Jan 1, 2001") {
                $('#txtDOB').val(formatDate_MMMDDYYYY(EmployeeInformation.DateOfBirth));
            }
            $('#txtAccountNumber').val(EmployeeInformation.BankAccountNo);
            $('#txtBank').val(EmployeeInformation.Bank);
            $('#txtPhoneNumber').val(EmployeeInformation.PhoneNumber);
            $('#txtEOBINumber').val(EmployeeInformation.EOBINo);

            this.initDocumentManager(EmployeeInformation.Id, EmployeeInformation.ClientId);
            this.initDocumentRequests(EmployeeInformation.Id, EmployeeInformation.ClientId);
        } else {
            this.loader.hideLoader();
        }

        this.loader.hideLoader();
    }

    private save = async () => {
        this.loader.showLoader();
        GetToken();

        let parseDateStr = (val: any) => {
            if (!val || val === "") return '1900-01-01';
            let d = new Date(String(val).trim());
            if (isNaN(d.getTime())) return '1900-01-01';
            let m = moment(d);
            return m.isValid() && m.year() > 1900 ? m.format("YYYY-MM-DD") : '1900-01-01';
        };

        let dataToSent: any = {
            LoginUserId: this.userData.Id,
            Department: $('#txtSection').val(),
            FirstName: $('#txtUserFirstName').val(),
            HireDate: parseDateStr($('#txtHireDate').val()),
            Designation: $('#txtDesignation').val(),
            PostingCity: $('#txtDepartment').val(),
            Cnic: $('#txtCNIC').val(),
            CnicIssueDate: parseDateStr($('#txtCNICIssueDate').val()),
            CnicExpiryDate: parseDateStr($('#txtCNICExpiryDate').val()),
            PhoneNumber: $('#txtPhoneNumber').val(),
            DateOfBirth: parseDateStr($('#txtDOB').val()),
            Address: $('#txtAddress').val(),
            City: $('#txtCity').val(),
            BankAccountNo: $('#txtAccountNumber').val(),
            Bank: $('#txtBank').val(),
            ReferenceName: $('#txtReferenceName').val(),
            ReferenceContact: $('#txtReferenceContact').val(),
            OfficialEmail: $('#txtOfficialEmail').val()
        };

        const empId: any = (this.$ddlEmpIds && this.$ddlEmpIds.length) ? this.$ddlEmpIds.val() : null;

        if (empId != undefined && empId != null && empId != "")
            dataToSent.LoginUserId = empId;

        const response = await http.post(this.constants.controller + "/UpdateEmployeeInfo", dataToSent);

        const data = httpPostHandleResponse(response);
        if (data) {
            sweetAlert(AlertType.Success, AlertTitle.Success, "Update Request has been sent to supervisor. Once Approved changes will reflect on your profile")
            this.loader.hideLoader();
        }
    }

    private initDocumentManager = (employeeId: any, clientId: any) => {
        this.documentManager = new DocumentManager({
            containerSelector: "#document-manager-container",
            entityId: employeeId,
            clientId: clientId,
            entityType: 'Employee',
            metadataEndpoint: baseAPIUrl() + "/DocumentType/GetAllActive",
            listEndpoint: this.constants.controllerDocuments + "/GetByEmployeeId/{id}",
            saveEndpoint: this.constants.controllerDocuments + "/AddDocuments",
            deleteEndpoint: this.constants.controllerDocuments + "/Delete"
        });
    };

    private initDocumentRequests = (employeeId: any, clientId: any) => {
        this.documentRequests = new DocumentRequests({
            containerSelector: "#document-requests-container",
            employeeId: employeeId,
            clientId: clientId
        });
    };
}

$(() => new Profile());